const config: {
  base_url: string
  result_code: number | string
  default_headers: string
  request_timeout: number
} = {
  /**
   * api请求基础路径
   * 只包含域名，/portal 前缀由 axios 拦截器自动添加
   * 生产环境使用空字符串（相对路径），开发环境使用 localhost
   */
  base_url: (() => {
    const envBaseUrl = import.meta.env.VITE_BASE_URL
    // 如果环境变量明确设置为空字符串，则使用空字符串（相对路径）
    // 如果未设置或为其他值，则使用该值或默认的 localhost
    const baseUrl = envBaseUrl === '' ? '' : (envBaseUrl || 'http://localhost:48080')
    console.log('[Config Debug] Calculated base_url:', baseUrl)
    return baseUrl
  })(),
  /**
   * 接口成功返回状态码
   */
  result_code: 200,

  /**
   * 接口请求超时时间
   */
  request_timeout: 30000,

  /**
   * 默认接口请求类型
   * 可选值：application/x-www-form-urlencoded multipart/form-data
   */
  default_headers: 'application/json'
}

export { config }
